import {
  deserify,
  getLocalStorage,
  getMediaBasePath,
  shouldIncludeCredentialsInRequest,
  useFeatureEnabled,
} from '@geneo2-web/shared-ui';
import { Feature } from '@protos/school_management/school.db_pb';
import { useEffect, useMemo, useState } from 'react';
import { useAppSelector } from '../reduxStore/reduxHooks';

export const useAuthentication = () => {
  const isAuthenticated = useMemo(() => {
    //check token in localStorage
    let auth = getLocalStorage('auth');
    if (auth === 'true' || auth === 'false') {
      auth = JSON.parse(auth);
    }
    return auth;
  }, []);

  return isAuthenticated;
};

export const useWhiteLabeledUrl = () => {
  const { userInfo } = deserify(useAppSelector((state) => state.auth));
  const featureInfo = userInfo?.schoolDetails?.featuresPlanInfo;
  const school_Id = userInfo?.schoolDetails?.schoolId;
  const logo_url = userInfo?.schoolDetails?.schoolWhiteLabelImageUrl;
  const isWhiteLabelingFeature = useFeatureEnabled(
    featureInfo,
    Feature.WHITE_LABELING
  );
  // if (!isWhiteLabelingFeature || !logo_url || !school_Id) {
  //   return undefined;
  // }
  // if (logo_url.startsWith('http')) {
  //   return logo_url;
  // }
  // return getMediaBasePath(
  //   `/school/${school_Id}/logos${logo_url}`,
  //   `schoolnetCdnImagesBucket`
  // );
  const [validatedUrl, setValidatedUrl] = useState<string | undefined>();

  useEffect(() => {
    let cancelled = false;

    const validateImage = async () => {
      if (!isWhiteLabelingFeature || !logo_url || !school_Id) {
        if (!cancelled) setValidatedUrl(undefined);
        return;
      }

      const finalUrl = logo_url.startsWith('http')
        ? logo_url
        : getMediaBasePath(
            `/school/${school_Id}/logos${logo_url}`,
            'schoolnetCdnImagesBucket'
          );

      const exists = await imageExists_2(finalUrl);

      console.log('Logo URL:', finalUrl);
      console.log('Image exists:', exists);

      if (!cancelled) {
        setValidatedUrl(exists ? finalUrl : undefined);
      }
    };

    validateImage();

    return () => {
      cancelled = true;
    };
  }, [logo_url, isWhiteLabelingFeature]);

  return validatedUrl;
};
const imageExists = async (url: string) => {
  try {
    const response = await fetch(url, {
      method: 'HEAD',
      credentials: shouldIncludeCredentialsInRequest(url)
        ? 'include'
        : 'same-origin',
    });
    return response.ok;
  } catch {
    return false;
  }
};

const imageExists_2 = (url: string): Promise<boolean> =>
  new Promise((resolve) => {
    const img = new Image();

    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);

    img.src = url;
  });

const GIL_COURSES_BOOK_IDS = [
  10175, 10162, 10176, 10360, 10361, 10362, 10363, 10364, 10365, 10366, 10367,
  10368,
];

export const useAllowResourceDownload = (subjectId?: number) => {
  const { userInfo } = deserify(useAppSelector((state) => state.auth));
  if (!subjectId) {
    return true;
  }
  const learnSubject = (userInfo?.learnSubjects || []).find(
    (sub) => sub.subjectId === subjectId
  );
  if (!learnSubject) {
    return true;
  }
  if (GIL_COURSES_BOOK_IDS.includes(learnSubject.bookId)) {
    return false;
  }
  return true;
};
